export function formatPatentDate(dateStr?: string): string {
  if (!dateStr) {
    return '';
  }

  const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  const parsedDate = new Date(dateStr);
  if (Number.isNaN(parsedDate.getTime())) {
    return dateStr;
  }

  return parsedDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatPatentApplicationNumber(appNum: string): string {
  if (!appNum || appNum.length < 8) {
    return appNum;
  }

  return `${appNum.slice(0, 2)}/${appNum.slice(2, 5)},${appNum.slice(5)}`;
}
